import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import isBetween from 'dayjs/plugin/isBetween'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import {
  allAvailableEventTypes,
  SESSION_PLATFORM_OFFLINE,
  VISIT_EVENT_TYPES,
} from 'src/consumer/constants'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)
import { v4 as uuidv4 } from 'uuid'
import { getAllClinicRelatedEventTypes } from './newBookingDialog/utils'

export function getAvailabilityForDayCalendar(
  selectedDate,
  timeZone,
  scheduleForSelectedEventType,
) {
  /////

  const neededSlotsInRangePerUserTZ = {
    visibleDate: selectedDate,
    dayStart: dayjs(selectedDate, 'DD-MM-YYYY')?.format(
      `YYYY-MM-DDTHH:mm:ss[${decodeURIComponent(timeZone)}]`,
    ),
    dayEnd: dayjs(selectedDate, 'DD-MM-YYYY')
      ?.endOf('day')
      ?.format(`YYYY-MM-DDTHH:mm:ss[${decodeURIComponent(timeZone)}]`),
  }

  const neededSlotsInRangePerUTC = {
    visibleDate: neededSlotsInRangePerUserTZ.visibleDate,
    dayStart: dayjs?.utc(neededSlotsInRangePerUserTZ.dayStart)?.format(`YYYY-MM-DDTHH:mm:ss[Z]`),
    dayEnd: dayjs?.utc(neededSlotsInRangePerUserTZ.dayEnd)?.format(`YYYY-MM-DDTHH:mm:ss[Z]`),
  }

  const neededSlotsInRangePerMentorTZ = {
    visibleDate: neededSlotsInRangePerUTC.visibleDate,
    dayStart: dayjs
      ?.utc(neededSlotsInRangePerUTC.dayStart)
      ?.utcOffset(decodeURIComponent(scheduleForSelectedEventType?.timeZone))
      ?.format(
        `YYYY-MM-DDTHH:mm:ss[${decodeURIComponent(scheduleForSelectedEventType?.timeZone)}]`,
      ),
    dayEnd: dayjs
      ?.utc(neededSlotsInRangePerUTC.dayEnd)
      ?.utcOffset(decodeURIComponent(scheduleForSelectedEventType?.timeZone))
      ?.format(
        `YYYY-MM-DDTHH:mm:ss[${decodeURIComponent(scheduleForSelectedEventType?.timeZone)}]`,
      ),
  }

  /////

  const selectedDateAvailabilityPerMentor = []
  if (
    neededSlotsInRangePerMentorTZ?.dayStart?.substring(0, 10) ===
    neededSlotsInRangePerMentorTZ?.dayEnd?.substring(0, 10)
  ) {
    const mentorDayData =
      scheduleForSelectedEventType?.weeklyHourMap?.[
        dayjs(neededSlotsInRangePerMentorTZ?.dayStart?.substring(0, 10))
          ?.format('dddd')
          ?.toLowerCase()
      ]
    if (mentorDayData && mentorDayData?.available) {
      mentorDayData?.slotList?.forEach((slotItem) => {
        selectedDateAvailabilityPerMentor?.push({
          startTime:
            neededSlotsInRangePerMentorTZ?.dayStart?.substring(0, 10) +
            'T' +
            slotItem?.startTime +
            decodeURIComponent(scheduleForSelectedEventType?.timeZone),
          endTime:
            neededSlotsInRangePerMentorTZ?.dayStart?.substring(0, 10) +
            'T' +
            slotItem?.endTime +
            decodeURIComponent(scheduleForSelectedEventType?.timeZone),
        })
      })
    }
  } else {
    const mentorStartDayData =
      scheduleForSelectedEventType?.weeklyHourMap?.[
        dayjs(neededSlotsInRangePerMentorTZ?.dayStart?.substring(0, 10))
          ?.format('dddd')
          ?.toLowerCase()
      ]
    const mentorEndDayData =
      scheduleForSelectedEventType?.weeklyHourMap?.[
        dayjs(neededSlotsInRangePerMentorTZ?.dayEnd?.substring(0, 10))
          ?.format('dddd')
          ?.toLowerCase()
      ]

    if (mentorStartDayData?.available) {
      mentorStartDayData?.slotList?.forEach((startDayItem) => {
        if (
          startDayItem?.startTime > neededSlotsInRangePerMentorTZ?.dayStart?.substring(11, 19) &&
          startDayItem?.endTime > neededSlotsInRangePerMentorTZ?.dayStart?.substring(11, 19)
        ) {
          selectedDateAvailabilityPerMentor?.push({
            startTime:
              neededSlotsInRangePerMentorTZ?.dayStart?.substring(0, 10) +
              'T' +
              startDayItem?.startTime +
              neededSlotsInRangePerMentorTZ?.dayStart?.substring(19),
            endTime:
              neededSlotsInRangePerMentorTZ?.dayStart?.substring(0, 10) +
              'T' +
              startDayItem?.endTime +
              neededSlotsInRangePerMentorTZ?.dayStart?.substring(19),
          })
        }
        if (
          startDayItem?.startTime < neededSlotsInRangePerMentorTZ?.dayStart?.substring(11, 19) &&
          startDayItem?.endTime > neededSlotsInRangePerMentorTZ?.dayStart?.substring(11, 19)
        ) {
          selectedDateAvailabilityPerMentor?.push({
            startTime:
              neededSlotsInRangePerMentorTZ?.dayStart?.substring(0, 10) +
              'T' +
              neededSlotsInRangePerMentorTZ?.dayStart?.substring(11, 19) +
              neededSlotsInRangePerMentorTZ?.dayStart?.substring(19),
            endTime:
              neededSlotsInRangePerMentorTZ?.dayStart?.substring(0, 10) +
              'T' +
              startDayItem?.endTime +
              neededSlotsInRangePerMentorTZ?.dayStart?.substring(19),
          })
        }
      })
    }

    if (mentorEndDayData?.available) {
      mentorEndDayData?.slotList?.forEach((endDayItem) => {
        if (
          endDayItem?.startTime < neededSlotsInRangePerMentorTZ?.dayEnd?.substring(11, 19) &&
          endDayItem?.endTime < neededSlotsInRangePerMentorTZ?.dayEnd?.substring(11, 19)
        ) {
          selectedDateAvailabilityPerMentor?.push({
            startTime:
              neededSlotsInRangePerMentorTZ?.dayEnd?.substring(0, 10) +
              'T' +
              endDayItem?.startTime +
              neededSlotsInRangePerMentorTZ?.dayEnd?.substring(19),
            endTime:
              neededSlotsInRangePerMentorTZ?.dayEnd?.substring(0, 10) +
              'T' +
              endDayItem?.endTime +
              neededSlotsInRangePerMentorTZ?.dayEnd?.substring(19),
          })
        }
        if (
          endDayItem?.startTime < neededSlotsInRangePerMentorTZ?.dayEnd?.substring(11, 19) &&
          endDayItem?.endTime > neededSlotsInRangePerMentorTZ?.dayEnd?.substring(11, 19)
        ) {
          selectedDateAvailabilityPerMentor?.push({
            startTime:
              neededSlotsInRangePerMentorTZ?.dayEnd?.substring(0, 10) +
              'T' +
              endDayItem?.startTime +
              neededSlotsInRangePerMentorTZ?.dayEnd?.substring(19),
            endTime:
              neededSlotsInRangePerMentorTZ?.dayEnd?.substring(0, 10) +
              'T' +
              neededSlotsInRangePerMentorTZ?.dayEnd?.substring(11, 19) +
              neededSlotsInRangePerMentorTZ?.dayEnd?.substring(19),
          })
        }
      })
    }
  }

  const selectedDateAvailabilityPerUTC = []
  selectedDateAvailabilityPerMentor?.forEach((slotItem) => {
    selectedDateAvailabilityPerUTC?.push({
      startTime: dayjs?.utc(slotItem?.startTime)?.format('YYYY-MM-DDTHH:mm:ss[Z]'),
      endTime: dayjs?.utc(slotItem?.endTime)?.format('YYYY-MM-DDTHH:mm:ss[Z]'),
    })
  })

  const selectedDateAvailabilityPerUser = []
  selectedDateAvailabilityPerUTC?.forEach((slotItem) => {
    selectedDateAvailabilityPerUser?.push({
      startTime: dayjs
        ?.utc(slotItem?.startTime)
        ?.utcOffset(decodeURIComponent(timeZone))
        ?.format(`YYYY-MM-DDTHH:mm:ss[${decodeURIComponent(timeZone)}]`),
      endTime: dayjs
        ?.utc(slotItem?.endTime)
        ?.utcOffset(decodeURIComponent(timeZone))
        ?.format(`YYYY-MM-DDTHH:mm:ss[${decodeURIComponent(timeZone)}]`),
    })
  })

  return selectedDateAvailabilityPerUser
}

export function getSlotGroupsForDayCalendar(
  availabilityOfDay,
  gapDurationInMins,
  timeZone,
  bookedSlotsInDay,
) {
  const slotGroupArray = []
  sortArrayMomentBased(availabilityOfDay, 'startTime', true)

  availabilityOfDay?.forEach((availableTimeBlock) => {
    const slotsOfThisTimeBlock = []
    let currentStartTime = dayjs(availableTimeBlock?.startTime)
    let currentSlotEnd = currentStartTime.add(gapDurationInMins, 'minutes')
    let endTime = dayjs(availableTimeBlock?.endTime)

    while (currentStartTime.isSameOrBefore(endTime) && currentSlotEnd.isSameOrBefore(endTime)) {
      const currentStartTimeFormatted = currentStartTime.format(
        `YYYY-MM-DDTHH:mm:ss[${decodeURIComponent(timeZone)}]`,
      )
      const currentSlotEndFormatted = currentSlotEnd.format(
        `YYYY-MM-DDTHH:mm:ss[${decodeURIComponent(timeZone)}]`,
      )
      slotsOfThisTimeBlock?.push({
        startTime: currentStartTimeFormatted,
        endTime: currentSlotEndFormatted,
      })
      currentStartTime = currentStartTime.add(gapDurationInMins, 'minutes')
      currentSlotEnd = currentSlotEnd.add(gapDurationInMins, 'minutes')
    }
    if (slotsOfThisTimeBlock?.length > 0) {
      slotGroupArray?.push(slotsOfThisTimeBlock)
    }
  })

  const referenceDay = slotGroupArray?.[0]?.[0]?.startTime

  slotGroupArray?.forEach((slotGroup, slotGroupIndex) => {
    const modifiedSlotGroup = [...slotGroup]
    let count = 1
    while (checkIfLastSlotHasOverlap(modifiedSlotGroup, bookedSlotsInDay)) {
      const proposedAddition = {
        startTime: dayjs(modifiedSlotGroup?.[modifiedSlotGroup?.length - 1]?.startTime)
          .add(gapDurationInMins, 'minutes')
          .format('YYYY-MM-DDTHH:mm:ssZZ'),
        endTime: dayjs(modifiedSlotGroup?.[modifiedSlotGroup?.length - 1]?.endTime)
          .add(gapDurationInMins, 'minutes')
          .format('YYYY-MM-DDTHH:mm:ssZZ'),
      }
      if (
        checkIfProposedSlotAllowed(
          proposedAddition?.endTime,
          slotGroupArray?.[slotGroupIndex + 1],
          referenceDay,
        )
      ) {
        modifiedSlotGroup.push(proposedAddition)
      } else {
        break
      }
      slotGroupArray[slotGroupIndex] = modifiedSlotGroup
    }
  })
  return slotGroupArray
}

export function getSlotGroupsForChamberRoomDayCalendar(
  availabilityOfDay,
  gapDurationInMins,
  timeZone,
) {
  const slotGroupArray = []
  sortArrayMomentBased(availabilityOfDay, 'startTime', true)

  availabilityOfDay?.forEach((availableTimeBlock) => {
    const slotsOfThisTimeBlock = []
    let currentStartTime = dayjs(availableTimeBlock?.startTime)
    let currentSlotEnd = currentStartTime.add(gapDurationInMins, 'minutes')
    let endTime = dayjs(availableTimeBlock?.endTime)

    while (currentStartTime.isSameOrBefore(endTime) && currentSlotEnd.isSameOrBefore(endTime)) {
      const currentStartTimeFormatted = currentStartTime.format(
        `YYYY-MM-DDTHH:mm:ss[${decodeURIComponent(timeZone)}]`,
      )
      const currentSlotEndFormatted = currentSlotEnd.format(
        `YYYY-MM-DDTHH:mm:ss[${decodeURIComponent(timeZone)}]`,
      )
      slotsOfThisTimeBlock?.push({
        startTime: currentStartTimeFormatted,
        endTime: currentSlotEndFormatted,
      })
      currentStartTime = currentStartTime.add(gapDurationInMins, 'minutes')
      currentSlotEnd = currentSlotEnd.add(gapDurationInMins, 'minutes')
    }
    if (slotsOfThisTimeBlock?.length > 0) {
      slotGroupArray?.push(slotsOfThisTimeBlock)
    }
  })

  return slotGroupArray
}

function checkIfLastSlotHasOverlap(slotGroup, bookedSlotsInDay) {
  let toReturn = false

  if (slotGroup?.length > 0) {
    const lastSlotOfGroup = slotGroup?.[slotGroup?.length - 1]
    bookedSlotsInDay?.forEach((bookedSlot) => {
      if (
        dayjs(bookedSlot?.startTimeForDayCal).isBetween(
          dayjs(lastSlotOfGroup.startTime),
          dayjs(lastSlotOfGroup?.endTime),
          null,
          '[]',
        ) ||
        dayjs(bookedSlot?.endTimeForDayCal).isBetween(
          dayjs(lastSlotOfGroup.startTime),
          dayjs(lastSlotOfGroup?.endTime),
          null,
          '[]',
        )
      ) {
        if (!toReturn) {
          toReturn = true
        }
      } else {
      }
    })
  } else {
  }

  return toReturn
}

function checkIfProposedSlotAllowed(endTimeOfProposedSlot, nextSlotGroup, referenceDay) {
  let toReturn = true
  if (referenceDay && endTimeOfProposedSlot) {
    if (
      !dayjs(referenceDay, 'YYYY-MM-DDTHH:mm:ssZZ').isSame(
        dayjs(endTimeOfProposedSlot, 'YYYY-MM-DDTHH:mm:ssZZ'),
        'day',
      )
    ) {
      // Not adding slot as new slot will be on new day
      return false
    }
  }
  if (nextSlotGroup && endTimeOfProposedSlot) {
    if (
      dayjs(endTimeOfProposedSlot, 'YYYY-MM-DDTHH:mm:ssZZ').isSameOrAfter(
        dayjs(nextSlotGroup?.[0]?.startTime, 'YYYY-MM-DDTHH:mm:ssZZ'),
      )
    ) {
      console.log('not adding slot as new slot will enter next slotgroup')
      return false
    }
  }
  return toReturn
}

export function sortArrayMomentBased(inputArray, fieldToCompare, ascending = true) {
  if (!inputArray) {
    return []
  }

  if (!Array.isArray(inputArray)) {
    console.warn('sortArrayMomentBased: inputArray must be an array')
    return []
  }

  if (!fieldToCompare || typeof fieldToCompare !== 'string') {
    console.warn('sortArrayMomentBased: fieldToCompare must be a string')
    return inputArray
  }

  // Create a copy to avoid mutating the original array
  return [...inputArray].sort((a, b) => {
    // Check if objects exist
    if (!a || !b) {
      return 0
    }

    // Get the values to compare
    const valueA = a?.[fieldToCompare]
    const valueB = b?.[fieldToCompare]

    // If either value is invalid, move it to the end of the array
    if (!valueA || !dayjs(valueA).isValid()) {
      return ascending ? 1 : -1
    }
    if (!valueB || !dayjs(valueB).isValid()) {
      return ascending ? -1 : 1
    }

    const dayjsA = dayjs(valueA)
    const dayjsB = dayjs(valueB)

    if (dayjsA.isSame(dayjsB)) {
      return 0
    }

    return ascending ? (dayjsA.isBefore(dayjsB) ? -1 : 1) : dayjsA.isBefore(dayjsB) ? 1 : -1
  })
}

export function getCorrectScreeningReasonMessageObject({
  eventType,
  isTryingToBookScreening,
  isScreenerAvailable,
  reasonIdForNotDoingScreening,
  reasonForNotDoingScreening,
}) {
  if (eventType === allAvailableEventTypes?.consultation) {
    if (isTryingToBookScreening) {
      if (!isScreenerAvailable) {
        return {
          id: 'screener_not_available',
          title: 'Screener not available',
        }
      }
      return null
    } else {
      return {
        id: reasonIdForNotDoingScreening,
        title: reasonForNotDoingScreening,
      }
    }
  }
  return null
}

//
//
// V2 DAY CAL:
//
//

export function getInitiallySelectedEventType(
  eventTypes,
  clinicLocationId,
  forceRegularVisitEventAsSelected,
  useClinicServices = false,
) {
  // if (useClinicServices) {
  //   const eTypes = (eventTypes || [])?.filter(
  //     (item) =>
  //       !!item?.enabled &&
  //       (item?.type === allAvailableEventTypes.consultation ||
  //         item.type === allAvailableEventTypes.therapySession),
  //   )
  //   if (eTypes?.length > 0) {
  //     let defaultETypes = eTypes
  //     const regularEvents = defaultETypes?.filter((item) => {
  //       return item?.visitEventType === VISIT_EVENT_TYPES.regular
  //     })

  //     return defaultETypes?.[0]
  //   }
  //   return undefined
  // }

  const eTypes = (eventTypes || [])?.filter((item) => {
    if (useClinicServices) {
      return (
        !!item?.enabled &&
        (item?.type === allAvailableEventTypes.consultation ||
          item.type === allAvailableEventTypes.therapySession)
      )
    }
    return (
      !!item?.enabled &&
      item?.contextId === clinicLocationId &&
      (item?.type === allAvailableEventTypes.consultation ||
        item.type === allAvailableEventTypes.therapySession)
    )
  })
  if (Array.isArray(eTypes) && eTypes.length > 0) {
    let defaultEventTypeInClinic = eTypes?.filter((item) => {
      if (useClinicServices) {
        return true
      }
      return item?.contextId === clinicLocationId && item?.defaultOfferingInClinic
    })

    const regularEvents = defaultEventTypeInClinic?.filter((item) => {
      return item?.visitEventType === VISIT_EVENT_TYPES.regular
    })
    //if regular events are actually there in the list. Use those only.
    if (regularEvents?.length > 0 && forceRegularVisitEventAsSelected) {
      defaultEventTypeInClinic = regularEvents
    }

    const inPersonEvents = eTypes?.filter((item) => {
      let clinicCheck = false
      if (useClinicServices) {
        clinicCheck = true
      } else {
        clinicCheck = item?.contextId === clinicLocationId
      }
      return clinicCheck && item?.meetingSrc === SESSION_PLATFORM_OFFLINE
    })

    const allClinicEvents = eTypes?.filter((item) =>
      useClinicServices ? true : item?.contextId === clinicLocationId,
    )

    //priority order for returns offeredDefaultEventType -> firstInPersonEvent -> firstClinicEvent
    if (defaultEventTypeInClinic?.[0]) {
      return defaultEventTypeInClinic?.[0]
    }
    if (inPersonEvents?.[0]) {
      return inPersonEvents?.[0]
    }
    return allClinicEvents[0]
  }
  return undefined
}

export function getInitiallySelectedEventTypeId(
  eventTypes,
  clinicLocationId,
  forceRegularVisitEventAsSelected,
  useClinicServices = false,
) {
  return getInitiallySelectedEventType(
    eventTypes,
    clinicLocationId,
    forceRegularVisitEventAsSelected,
    useClinicServices,
  )?.uid
}

export function getInitiallySelectedEventTypeData(
  eventTypes,
  clinicLocationId,
  useClinicServices = false,
) {
  const decidedInitiallySelectedEventTypeId = getInitiallySelectedEventTypeId(
    eventTypes,
    clinicLocationId,
    undefined,
    useClinicServices,
  )
  console.log('Inside getInitiallySelectedEventTypeData', {
    decidedInitiallySelectedEventTypeId,
    clinicLocationId,
  })
  if (decidedInitiallySelectedEventTypeId) {
    return (eventTypes || [])?.find((item) => item?.uid === decidedInitiallySelectedEventTypeId)
  }
  return undefined
}

export function getEventDataFromMentorProfileData(eventTypeId, mentorProfileData) {
  if (eventTypeId) {
    return (mentorProfileData?.eventTypes || [])?.find((item) => item?.uid === eventTypeId)
  }
  return undefined
}

export function isProposedSlotOverlappingOverExistingBooking() {}

export function isMentorAvailableInThisSlot() {}

export function getMentorAvailabilityOnThisDay(
  selectedDate,
  timeZone,
  scheduleForSelectedEventType,
) {
  return getAvailabilityForDayCalendar(selectedDate, timeZone, {
    timeZone: timeZone,
    ...scheduleForSelectedEventType,
  })
}

export function getDefaultSlotDuration(mentorProfileData) {
  const eventTypes = mentorProfileData?.eventTypes
  if (Array.isArray(mentorProfileData?.eventTypes) && eventTypes?.length > 0) {
    let minDuration = eventTypes?.[0]?.durationInMins
    eventTypes?.forEach((eventType) => {
      if (eventType?.durationInMins && eventType?.durationInMins < minDuration) {
        minDuration = eventType?.durationInMins
      }
    })
    return minDuration
  }
  return 17
}

/**
 * Extract all event types from roomData's checkInEventOptions
 * This gets the event types directly from the room configuration
 * @param {Array} checkInEventOptions - Array of check-in event options from roomData
 * @param {Array} mentorEventTypes - Mentor's event types (for fallback matching when eventTypes not provided)
 * @param {string} clinicId - Current clinic ID
 * @returns {Array} Array of event types from roomData
 */
export function getEventTypesFromRoomData(checkInEventOptions, mentorEventTypes = [], clinicId) {
  if (!checkInEventOptions || !Array.isArray(checkInEventOptions)) {
    return []
  }

  const extractedEventTypes = []
  const seenEventTypeIds = new Set()

  checkInEventOptions.forEach((option) => {
    // If option has full eventTypes array (preferred - most complete data)
    if (option?.eventTypes && Array.isArray(option.eventTypes)) {
      option.eventTypes.forEach((et) => {
        const id = et?.uid || et?.id
        if (id && !seenEventTypeIds.has(id)) {
          seenEventTypeIds.add(id)
          // Ensure event type has required fields, filter by clinic if needed
          if (!clinicId || et?.contextId === clinicId) {
            extractedEventTypes.push(et)
          }
        }
      })
    }
    // If option has eventTypeIds array, match with mentorEventTypes
    else if (option?.eventTypeIds && Array.isArray(option.eventTypeIds)) {
      option.eventTypeIds.forEach((eventTypeId) => {
        if (!seenEventTypeIds.has(eventTypeId)) {
          seenEventTypeIds.add(eventTypeId)
          const matchedEventType = mentorEventTypes.find(
            (et) => (et?.uid === eventTypeId || et?.id === eventTypeId) &&
                    et?.enabled &&
                    (!clinicId || et?.contextId === clinicId)
          )
          if (matchedEventType) {
            extractedEventTypes.push(matchedEventType)
          }
        }
      })
    }
    // If option has single eventTypeId
    else if (option?.eventTypeId) {
      if (!seenEventTypeIds.has(option.eventTypeId)) {
        seenEventTypeIds.add(option.eventTypeId)
        const matchedEventType = mentorEventTypes.find(
          (et) => (et?.uid === option.eventTypeId || et?.id === option.eventTypeId) &&
                  et?.enabled &&
                  (!clinicId || et?.contextId === clinicId)
        )
        if (matchedEventType) {
          extractedEventTypes.push(matchedEventType)
        }
      }
    }
  })

  return extractedEventTypes
}

/**
 * Get event types from check-in event option
 * This handles cases like "screening-only" which maps to multiple screening event types
 * @param {Object} checkInEventOption - The check-in event option object
 * @param {Array} mentorEventTypes - All mentor event types
 * @param {string} clinicId - Current clinic ID
 * @returns {Array} Array of matching event types
 */
export function getEventTypesFromCheckInOption(checkInEventOption, mentorEventTypes, clinicId) {
  if (!checkInEventOption || !mentorEventTypes || !Array.isArray(mentorEventTypes)) {
    return []
  }

  let matchingEventTypes = []

  // If the option has eventTypeIds array (e.g., screening-only maps to multiple screening event types)
  if (checkInEventOption?.eventTypeIds && Array.isArray(checkInEventOption.eventTypeIds)) {
    matchingEventTypes = mentorEventTypes.filter((et) =>
      checkInEventOption.eventTypeIds.includes(et?.uid) || checkInEventOption.eventTypeIds.includes(et?.id)
    )
  }
  // If the option has eventTypes array
  else if (checkInEventOption?.eventTypes && Array.isArray(checkInEventOption.eventTypes)) {
    matchingEventTypes = mentorEventTypes.filter((et) =>
      checkInEventOption.eventTypes.some((optEt) => optEt?.uid === et?.uid || optEt?.id === et?.id)
    )
  }
  // If the option has a single eventTypeId
  else if (checkInEventOption?.eventTypeId) {
    const eventType = mentorEventTypes.find(
      (et) => et?.uid === checkInEventOption.eventTypeId || et?.id === checkInEventOption.eventTypeId
    )
    if (eventType) {
      matchingEventTypes = [eventType]
    }
  }
  // If the option has a direct type field
  else if (checkInEventOption?.type) {
    matchingEventTypes = mentorEventTypes.filter(
      (et) => et?.type === checkInEventOption.type
    )
  }

  // Filter by clinic ID and enabled status
  return matchingEventTypes.filter(
    (et) => et?.enabled && et?.contextId === clinicId
  )
}

/**
 * Get slot duration based on check-in event type
 * @param {Object} mentorProfileData - Mentor profile data with eventTypes
 * @param {string} clinicId - Current clinic ID
 * @param {string} checkInEventOptionId - Check-in event option ID from localStorage
 * @param {Array} checkInEventOptions - Optional array of check-in event options from roomData
 * @param {Array} roomDataEventTypes - Optional array of event types extracted from roomData
 * @returns {number} Slot duration in minutes
 */
export function getSlotDurationBasedOnCheckIn(
  mentorProfileData,
  clinicId,
  checkInEventOptionId,
  checkInEventOptions = null,
  roomDataEventTypes = null,
) {
  // Default durations for each event type
  const DEFAULT_DURATIONS = {
    [allAvailableEventTypes.consultation]: 15,
    [allAvailableEventTypes.therapySession]: 30,
    [allAvailableEventTypes.screening]: 15,
    [allAvailableEventTypes.oneOnOne]: 20,
    [allAvailableEventTypes.assessment]: 30,
    [allAvailableEventTypes.interview]: 60,
  }

  // Merge roomDataEventTypes with mentorProfileData eventTypes
  // roomDataEventTypes take precedence as they come from the room configuration
  let availableEventTypes = mentorProfileData?.eventTypes || []
  
  if (roomDataEventTypes && roomDataEventTypes.length > 0) {
    // Use roomData eventTypes as primary source, merge with mentor eventTypes
    const roomDataEventTypeIds = new Set(roomDataEventTypes.map(et => et?.uid || et?.id))
    const mentorEventTypesNotInRoom = (mentorProfileData?.eventTypes || []).filter(
      et => !roomDataEventTypeIds.has(et?.uid || et?.id)
    )
    availableEventTypes = [...roomDataEventTypes, ...mentorEventTypesNotInRoom]
    console.log('[getSlotDurationBasedOnCheckIn] Using merged eventTypes:', {
      roomDataEventTypes: roomDataEventTypes.length,
      mentorEventTypes: mentorEventTypesNotInRoom.length,
      total: availableEventTypes.length
    })
  }

  // If no check-in event option or clinic ID, fall back to clinic-related event types (excluding screening)
  if (!checkInEventOptionId || !clinicId) {
    // Try roomDataEventTypes first for default calculation
    if (roomDataEventTypes && roomDataEventTypes.length > 0) {
      const defaultFromRoomData = getDefaultSlotDuration({ eventTypes: roomDataEventTypes })
      if (defaultFromRoomData) {
        console.log('[getSlotDurationBasedOnCheckIn] Using default from roomDataEventTypes:', defaultFromRoomData)
        return defaultFromRoomData
      }
    }
    const clinicEventTypes = getAllClinicRelatedEventTypes(availableEventTypes, clinicId)
    return getDefaultSlotDuration({ eventTypes: clinicEventTypes }) || 15
  }

  let matchingEventTypes = []
  let checkInOptionType = null // 'screening-only', 'therapy-only', 'screening-and-therapy', or null

  // First, try to find the check-in option and get its event types
  let selectedOption = null
  if (checkInEventOptions && Array.isArray(checkInEventOptions)) {
    selectedOption = checkInEventOptions.find((option) => option?.id === checkInEventOptionId)
    if (selectedOption) {
      matchingEventTypes = getEventTypesFromCheckInOption(
        selectedOption,
        availableEventTypes, // Use merged eventTypes instead of just mentorProfileData
        clinicId
      )
      
      // Detect check-in option type from title
      const optionTitle = (selectedOption.title || selectedOption.name || '').toLowerCase()
      
      // Determine the check-in option type based on title
      if (optionTitle.includes('screening') && optionTitle.includes('therapy')) {
        checkInOptionType = 'screening-and-therapy'
      } else if (optionTitle.includes('therapy') && optionTitle.includes('only')) {
        checkInOptionType = 'therapy-only'
      } else if (optionTitle.includes('screening') && (optionTitle.includes('only') || optionTitle.includes('screening-only'))) {
        checkInOptionType = 'screening-only'
      } else if (optionTitle.includes('screening') && !optionTitle.includes('therapy')) {
        checkInOptionType = 'screening-only'
      }
    }
  }
  
  // If selectedOption not found but checkInEventOptionId looks like a type identifier, detect from ID
  if (!selectedOption && checkInEventOptionId) {
    const checkInEventOptionIdLower = checkInEventOptionId.toLowerCase()
    if (checkInEventOptionIdLower.includes('screening') && checkInEventOptionIdLower.includes('therapy')) {
      checkInOptionType = 'screening-and-therapy'
    } else if (checkInEventOptionIdLower.includes('therapy') && checkInEventOptionIdLower.includes('only')) {
      checkInOptionType = 'therapy-only'
    } else if (checkInEventOptionIdLower.includes('screening')) {
      if (checkInEventOptionIdLower.includes('only') || checkInEventOptionIdLower === 'screening-only') {
        checkInOptionType = 'screening-only'
      } else if (!checkInEventOptionIdLower.includes('therapy')) {
        checkInOptionType = 'screening-only'
      }
    }
    console.log('[getSlotDurationBasedOnCheckIn] Detected check-in option type from ID:', checkInOptionType, checkInEventOptionId)
    
    // If we detected the type from ID and still don't have matching events, search for them now
    if (checkInOptionType && matchingEventTypes.length === 0) {
      if (checkInOptionType === 'screening-only') {
        matchingEventTypes = availableEventTypes.filter(
          (et) => et?.enabled &&
                  et?.contextId === clinicId &&
                  et?.type === allAvailableEventTypes.screening
        )
        console.log('[getSlotDurationBasedOnCheckIn] Found screening events from ID detection:', matchingEventTypes.length)
      } else if (checkInOptionType === 'therapy-only') {
        matchingEventTypes = availableEventTypes.filter(
          (et) => et?.enabled &&
                  et?.contextId === clinicId &&
                  (et?.type === allAvailableEventTypes.therapySession || et?.type === allAvailableEventTypes.assessment)
        )
        console.log('[getSlotDurationBasedOnCheckIn] Found therapy/assessment events from ID detection:', matchingEventTypes.length)
      } else if (checkInOptionType === 'screening-and-therapy') {
        matchingEventTypes = availableEventTypes.filter(
          (et) => et?.enabled &&
                  et?.contextId === clinicId &&
                  (et?.type === allAvailableEventTypes.screening ||
                   et?.type === allAvailableEventTypes.therapySession ||
                   et?.type === allAvailableEventTypes.assessment)
        )
        console.log('[getSlotDurationBasedOnCheckIn] Found screening+therapy+assessment events from ID detection:', matchingEventTypes.length)
      }
    }
  }

  // If we found matching event types from the check-in option
  if (matchingEventTypes.length > 0) {
    // Find minimum duration among matching event types
    let minDuration = matchingEventTypes[0]?.durationInMins
    matchingEventTypes.forEach((eventType) => {
      if (eventType?.durationInMins && eventType.durationInMins < minDuration) {
        minDuration = eventType.durationInMins
      }
    })
    
    // If we have durations, use the minimum
    if (minDuration) {
      console.log('[getSlotDurationBasedOnCheckIn] Found matching event types, using min duration:', minDuration, matchingEventTypes)
      return minDuration
    }
    
    // Otherwise, try to get default based on the event type
    const eventTypeValue = matchingEventTypes[0]?.type
    if (eventTypeValue && DEFAULT_DURATIONS[eventTypeValue]) {
      console.log('[getSlotDurationBasedOnCheckIn] Using default for event type:', eventTypeValue, DEFAULT_DURATIONS[eventTypeValue])
      return DEFAULT_DURATIONS[eventTypeValue]
    }
  }

  // If we didn't find matching events via getEventTypesFromCheckInOption, 
  // try to find events based on the detected check-in option type
  if (matchingEventTypes.length === 0 && checkInOptionType) {
        let eventsToUse = []
        
        if (checkInOptionType === 'screening-only') {
          // Find all screening event types from availableEventTypes (includes roomDataEventTypes)
          eventsToUse = availableEventTypes.filter(
            (et) => et?.enabled &&
                    et?.contextId === clinicId &&
                    et?.type === allAvailableEventTypes.screening
          )
          console.log('[getSlotDurationBasedOnCheckIn] Found screening-only option, looking for screening events:', eventsToUse)
        } else if (checkInOptionType === 'therapy-only') {
          // Find all therapy and assessment event types from availableEventTypes
          eventsToUse = availableEventTypes.filter(
            (et) => et?.enabled &&
                    et?.contextId === clinicId &&
                    (et?.type === allAvailableEventTypes.therapySession || et?.type === allAvailableEventTypes.assessment)
          )
          console.log('[getSlotDurationBasedOnCheckIn] Found therapy-only option, looking for therapy/assessment events:', eventsToUse)
        } else if (checkInOptionType === 'screening-and-therapy') {
          // Find all screening, therapy, and assessment event types from availableEventTypes
          eventsToUse = availableEventTypes.filter(
            (et) => et?.enabled &&
                    et?.contextId === clinicId &&
                    (et?.type === allAvailableEventTypes.screening ||
                     et?.type === allAvailableEventTypes.therapySession ||
                     et?.type === allAvailableEventTypes.assessment)
          )
          console.log('[getSlotDurationBasedOnCheckIn] Found screening-and-therapy option, looking for all three types:', eventsToUse)
        }
        
        if (eventsToUse.length > 0) {
          let minDuration = eventsToUse[0]?.durationInMins
          eventsToUse.forEach((eventType) => {
            if (eventType?.durationInMins && eventType.durationInMins < minDuration) {
              minDuration = eventType.durationInMins
            }
          })
          if (minDuration) {
            console.log('[getSlotDurationBasedOnCheckIn] Using min duration from', checkInOptionType, 'events:', minDuration)
            return minDuration
          }
          
          // If no durations found, use default based on type
          if (checkInOptionType === 'screening-only') {
            console.log('[getSlotDurationBasedOnCheckIn] Using default for screening:', DEFAULT_DURATIONS[allAvailableEventTypes.screening])
            return DEFAULT_DURATIONS[allAvailableEventTypes.screening]
          } else if (checkInOptionType === 'therapy-only') {
            // Use minimum of therapy and assessment defaults
            const therapyDefault = DEFAULT_DURATIONS[allAvailableEventTypes.therapySession]
            const assessmentDefault = DEFAULT_DURATIONS[allAvailableEventTypes.assessment]
            const minDefault = Math.min(therapyDefault, assessmentDefault)
            console.log('[getSlotDurationBasedOnCheckIn] Using default for therapy-only:', minDefault)
            return minDefault
          } else if (checkInOptionType === 'screening-and-therapy') {
            // Use minimum of all three defaults
            const screeningDefault = DEFAULT_DURATIONS[allAvailableEventTypes.screening]
            const therapyDefault = DEFAULT_DURATIONS[allAvailableEventTypes.therapySession]
            const assessmentDefault = DEFAULT_DURATIONS[allAvailableEventTypes.assessment]
            const minDefault = Math.min(screeningDefault, therapyDefault, assessmentDefault)
            console.log('[getSlotDurationBasedOnCheckIn] Using default for screening-and-therapy:', minDefault)
            return minDefault
          }
        }
      }

  // Fallback: try to find by matching checkInEventOptionId directly with event type IDs/UIDs
  if (availableEventTypes && Array.isArray(availableEventTypes)) {
    const checkInEventType = availableEventTypes.find(
      (et) => (et?.uid === checkInEventOptionId || et?.id === checkInEventOptionId) &&
              et?.enabled &&
              et?.contextId === clinicId
    )
    if (checkInEventType) {
      console.log('[getSlotDurationBasedOnCheckIn] Found direct match by ID:', checkInEventType)
      return checkInEventType.durationInMins || DEFAULT_DURATIONS[checkInEventType.type] || 15
    }
  }

  // If we couldn't find the event type, fall back to clinic-related event types (excluding screening)
  // BUT: if we detected a specific check-in option type, use appropriate default instead
  if (checkInOptionType === 'screening-only') {
    console.log('[getSlotDurationBasedOnCheckIn] Screening-only detected, using screening default:', DEFAULT_DURATIONS[allAvailableEventTypes.screening])
    return DEFAULT_DURATIONS[allAvailableEventTypes.screening]
  } else if (checkInOptionType === 'therapy-only') {
    const therapyDefault = DEFAULT_DURATIONS[allAvailableEventTypes.therapySession]
    const assessmentDefault = DEFAULT_DURATIONS[allAvailableEventTypes.assessment]
    const minDefault = Math.min(therapyDefault, assessmentDefault)
    console.log('[getSlotDurationBasedOnCheckIn] Therapy-only detected, using min default:', minDefault)
    return minDefault
  } else if (checkInOptionType === 'screening-and-therapy') {
    const screeningDefault = DEFAULT_DURATIONS[allAvailableEventTypes.screening]
    const therapyDefault = DEFAULT_DURATIONS[allAvailableEventTypes.therapySession]
    const assessmentDefault = DEFAULT_DURATIONS[allAvailableEventTypes.assessment]
    const minDefault = Math.min(screeningDefault, therapyDefault, assessmentDefault)
    console.log('[getSlotDurationBasedOnCheckIn] Screening-and-therapy detected, using min default:', minDefault)
    return minDefault
  }

  // Try roomDataEventTypes first for default calculation, but filter by detected check-in option type if available
  if (roomDataEventTypes && roomDataEventTypes.length > 0) {
    let eventTypesToUse = roomDataEventTypes
    
    // If we detected a check-in option type, filter roomDataEventTypes accordingly
    if (checkInOptionType === 'screening-only') {
      eventTypesToUse = roomDataEventTypes.filter(
        (et) => et?.type === allAvailableEventTypes.screening
      )
      console.log('[getSlotDurationBasedOnCheckIn] Filtering roomDataEventTypes for screening-only:', eventTypesToUse.length, 'events')
    } else if (checkInOptionType === 'therapy-only') {
      eventTypesToUse = roomDataEventTypes.filter(
        (et) => et?.type === allAvailableEventTypes.therapySession || et?.type === allAvailableEventTypes.assessment
      )
      console.log('[getSlotDurationBasedOnCheckIn] Filtering roomDataEventTypes for therapy-only:', eventTypesToUse.length, 'events')
    } else if (checkInOptionType === 'screening-and-therapy') {
      eventTypesToUse = roomDataEventTypes.filter(
        (et) => et?.type === allAvailableEventTypes.screening ||
                et?.type === allAvailableEventTypes.therapySession ||
                et?.type === allAvailableEventTypes.assessment
      )
      console.log('[getSlotDurationBasedOnCheckIn] Filtering roomDataEventTypes for screening-and-therapy:', eventTypesToUse.length, 'events')
    }
    
    if (eventTypesToUse.length > 0) {
      const defaultFromRoomData = getDefaultSlotDuration({ eventTypes: eventTypesToUse })
      if (defaultFromRoomData) {
        console.log('[getSlotDurationBasedOnCheckIn] Using default from filtered roomDataEventTypes:', defaultFromRoomData)
        return defaultFromRoomData
      }
    }
  }

  const clinicEventTypes = getAllClinicRelatedEventTypes(availableEventTypes, clinicId)
  const fallbackDuration = getDefaultSlotDuration({ eventTypes: clinicEventTypes }) || 15
  console.log('[getSlotDurationBasedOnCheckIn] Falling back to clinic event types (excluding screening):', fallbackDuration, clinicEventTypes)
  return fallbackDuration
}

export function generateAumhumLocalMailIdForUser(name) {
  if (!name) {
    name = ''
  }
  let userName = name.toLowerCase().replace(/[^a-z0-9]/g, '') // Remove non-alphanumeric characters
  let uniqueId = uuidv4()
    .replace(/[^a-z0-9]/gi, '')
    .slice(0, 12) // 12 chars for uniqueness

  // Ensure the local part does not exceed 64 characters
  let localPart = `${userName}${uniqueId}`.slice(0, 64)

  return `${localPart}@aumhum.xyz`
}
